import { lang } from '@umu/ukit-lang';
/**
 * @description 评论保存接口
 * @author duanjun
 */

import Api from '@umu/umu-api';
import { fetchData } from '@umu/umu-fetch';
import { CommentParentType, CommentType, CommentSubjectType, ERROR_CODE, IComment, IResponse } from '@umu/umu-types';
import { services } from 'common';
const { Toast } = services;

interface IInput {
    parent_type: CommentParentType;
    parent_id: number;
    comment_type: CommentType;
    comment: string;
    extend?: any;
    comment_parent_id?: number;
    show_parent_id?: number; // 显示的时候的parentId。需求有些地方需要拍平显示
    note_state?: number;
    question_id?: number; // 问题id，兼容APP老版本，新版本请使用subject_id和subject_type组合
    nick_name?: string; // （仅parent_type为4有效）用户昵称
    is_anonymous?: 0 | 1; // （仅parent_type为4有效）是否匿名
    subject_id?: number; // 主题id，类型对应的id，比如问题id，照片id和班级feed id
    subject_type?: CommentSubjectType; // 主题类型，0:问题类型 1:小节照片类型 2:班级feed类型
}

interface IOutput {
    comment_info: IComment;
}

export type IResponseData = IResponse<IOutput>;

export const saveComment = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(
        Api.Path.SAVE_COMMENT,
        Object.assign(
            {
                show_parent_id: 0,
                comment_parent_id: 0,
            },
            data,
        ),
        { silent: true },
    ).then((res: IResponseData) => {
        if (res.error_code) {
            commentSaveErrHandle(res.error_code);
        }
        return res;
    });
};

export const commentSaveErrHandle = (code: number, errorMsg?: string) => {
    switch (code) {
        case ERROR_CODE.HAS_SENSITIVE_WORDS:
            Toast.show({ message: lang('提交失败，你的内容里包含敏感词，请检查后再试') });
            break;
        case ERROR_CODE.NO_LOGIN:
            Toast.show(lang('请先登录'));
            break;
        case ERROR_CODE.DEBUG_AUTH:
            Toast.show(lang('每个账户每天最多生成 10 个授权链接，当前已达到次数上限，无法继续生成授权链接。'));
        case ERROR_CODE.SERVER_ERROR:
            Toast.show(errorMsg || lang('请先登录'));
            break;
        default:
            break;
    }
};
